<ng-container [ngSwitch]="disruptionMessage?.severity">
    <p
        class="bg-grey-light var-app-dark:!bg-contrast-white orb-app-dark:!bg-contrast-white flex rounded-[3px] px-1.5 py-[7px] text-black"
        *ngSwitchCase="DisruptionMessageSeverity.CRITICAL"
        [ngClass]="commonExtraClasses"
        (click)="openDisruptionMessageDetailsView(disruptionMessage)">
        <ion-icon
            class="text-red-alert_icon var-app-dark:text-black orb-app-dark:text-black mr-1 h-4 w-4 shrink-0"
            [ngClass]="{ 'var-app-light:text-red-alert': env.IS_NEW_AFC }"
            src="{{ assetsPath$ | async }}/img/journey-planner/icon-alert-circle.svg"></ion-icon>
        <span [ngClass]="commonExtraSpanClasses">{{ disruptionMessage.headerTextDefault }}</span>
    </p>

    <p
        class="bg-grey-light var-app-dark:!bg-contrast-white orb-app-dark:!bg-contrast-white flex items-center rounded-[3px] px-1.5 py-[7px] text-black"
        *ngSwitchCase="DisruptionMessageSeverity.INFO"
        [ngClass]="commonExtraClasses">
        <ion-icon
            class="text-blue-alert_icon var-app-dark:text-black orb-app-dark:text-black mr-1 h-4 w-4 shrink-0"
            src="{{ assetsPath$ | async }}/img/journey-planner/icon-info-no-color.svg"></ion-icon>
        <span [ngClass]="commonExtraSpanClasses">{{ disruptionMessage?.descriptionTextDefault }}</span>
    </p>

    <!-- WARNING (default) -->
    <p
        class="gl-light:bg-orange-alert var-app-dark:!bg-contrast-white orb-app-dark:!bg-contrast-white flex cursor-pointer rounded-[3px] bg-yellow-alert px-1.5 py-[7px] text-black"
        *ngSwitchDefault
        [ngClass]="commonExtraClasses"
        (click)="openDisruptionMessageDetailsView(disruptionMessage)">
        <ion-icon
            class="tartu-light:text-yellow-alert mr-1 h-4 w-4 shrink-0"
            src="{{ assetsPath$ | async }}/img/journey-planner/alert-triangle-no-color.svg"></ion-icon>
        <span [ngClass]="commonExtraSpanClasses">{{ disruptionMessage?.headerTextDefault }}</span>
        <span class="inline-flex" *ngIf="!this.env.JOURNEY_PLANNER?.SHOW_ALERT_BUTTON_MORE"
            ><ion-icon name="arrow-forward-outline"></ion-icon>
        </span>
    </p>
</ng-container>
